module.exports = __webpack_public_path__ + "img/p4-p1-bg.5800fc4b.jpg";